/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { ISnackbarAlert } from "../../shared/snackbar/SnackbarAlert";
import { SNACKBAR_MESSAGE } from "./types";

export const setSnackBarDisplay = (snackBarAlertProps: ISnackbarAlert) => {
  return {
    type: SNACKBAR_MESSAGE,
    snackBarAlertProps,
  };
};
